import { isBlank } from "@xflr6/utils";

export const getIsPointagramAddedOn = (
  config?: Record<string, string>
): boolean =>
  config != null &&
  !isBlank(config["pointagramApiKey"]) &&
  !isBlank(config["pointagramApiUser"]);
